import { Utilities } from '@microsoft/office-js-helpers'

import makePromise from './make-promise'
import { onPromiseTimeout } from './utils/promise'
import { logAndResolve } from '../services/loft/actions'
import { getAccessToken } from './nested-app-auth/authHelper'
import { captureException } from '../sentry-config'

export default class OutlookMailbox {
  constructor(office) {
    this.office = office
  }

  token = async (isRest = false, isNaaEnabled) => {
    if (isNaaEnabled) {
      const accessToken = await getAccessToken(['user.read', 'offline_access'])

      return accessToken
    }

    return onPromiseTimeout(
      makePromise(
        this.mailbox.getCallbackTokenAsync,
        this.mailbox
      )({ isRest }).catch(error => {
        captureException(new Error(error.name || 'OutlookMailbox#token'), {
          fingerprint: ['OutlookMailbox#token'],
          extra: {
            message: error.message,
            code: error.code,
            traceMessages: error.traceMessages || [],
          },
        })
        return null
      }),
      logAndResolve(null),
      1500
    )
  }

  get mailbox() {
    return this.office.context.mailbox
  }

  get platform() {
    return Utilities.platform
  }

  async restConnection(isNaaEnabled) {
    return {
      restUrl: this.mailbox.restUrl,
      restToken: await this.token(true, isNaaEnabled),
    }
  }

  getAppDisplayLanguage() {
    return this.office.context.displayLanguage
  }
}
